import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

let id_from_get = window.location.search.substring(1) ? window.location.search.substring(1) : 'x';

ReactDOM.render(<App id_from_get={id_from_get} />, document.getElementById('root'));
